import { REACTIONS_ATTRIBUTES as w } from "./emoji-row-constants.js";
import { DialtoneLocalization as C } from "../../localization/index.js";
import { getEmojiShortCode as b } from "../../common/emoji/index.js";
import { resolveComponent as n, openBlock as l, createElementBlock as d, Fragment as E, renderList as S, createVNode as m, withCtx as s, createElementVNode as t, toDisplayString as c, createTextVNode as k, normalizeClass as O, renderSlot as v } from "vue";
import { _ as x } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import D from "../emoji-text-wrapper/emoji-text-wrapper.js";
import T from "../emoji/emoji.js";
import L from "../button/button.js";
import I from "../tooltip/tooltip.js";
const g = {
  compatConfig: { MODE: 3 },
  name: "DtRecipeEmojiRow",
  components: { DtTooltip: I, DtButton: L, DtEmoji: T, DtEmojiTextWrapper: D },
  props: {
    /**
     * Provide an array of reaction objects to be shown.
     */
    reactions: {
      type: Array,
      default: () => [],
      validator: (e) => {
        for (const i of e)
          if (!w.every((_) => i[_] !== void 0)) return !1;
        return !0;
      }
    }
  },
  emits: [
    "emoji-clicked",
    "emoji-hovered"
  ],
  data() {
    return {
      i18n: new C()
    };
  },
  methods: {
    emojiClicked(e) {
      this.$emit("emoji-clicked", e.emojiUnicodeOrShortname);
    },
    emojiHovered(e, i) {
      this.$emit("emoji-hovered", {
        reaction: e.emojiUnicodeOrShortname,
        state: i
      });
    },
    reactionLabel(e) {
      return this.i18n.$t("DIALTONE_EMOJI_ROW_REACTION_LABEL", {
        reaction: b(e.emojiUnicodeOrShortname),
        personCount: e.num
      });
    }
  }
}, y = { class: "d-recipe-emoji-row" }, A = { "aria-hidden": "true" }, N = { class: "d-recipe-emoji-row__tooltip-emoji" }, R = { class: "d-recipe-emoji-row__tooltip-names" }, U = ["textContent"], z = { class: "d-recipe-emoji-row__emoji" }, B = { class: "d-recipe-emoji-row__reaction-number" };
function $(e, i, p, _, V, r) {
  const j = n("dt-emoji-text-wrapper"), u = n("dt-emoji"), f = n("dt-button"), h = n("dt-tooltip");
  return l(), d("span", y, [
    (l(!0), d(E, null, S(p.reactions, (o) => (l(), d("span", {
      key: o.unicodeOutput
    }, [
      m(h, {
        class: "d-recipe-emoji-row__tooltip",
        "content-class": "d-recipe-emoji-row__tooltip-content",
        "fallback-placements": ["top", "bottom"],
        sticky: "popper",
        onShown: (a) => r.emojiHovered(o, a)
      }, {
        anchor: s(({ attrs: a }) => [
          m(f, {
            importance: "clear",
            size: "sm",
            "data-qa": "feed-item-reaction-button",
            class: O([
              "d-recipe-emoji-row__reaction",
              o.isSelected ? "d-recipe-emoji-row__reaction--selected" : ""
            ]),
            "aria-label": r.reactionLabel(o),
            attrs: a,
            onClick: (H) => r.emojiClicked(o)
          }, {
            default: s(() => [
              t("span", z, [
                m(u, {
                  class: "d-recipe-emoji-row__emoji",
                  size: "200",
                  "img-class": "d-recipe-emoji-row__emoji-img",
                  code: o.emojiUnicodeOrShortname
                }, null, 8, ["code"])
              ]),
              t("span", B, c(o.num), 1)
            ]),
            _: 2
          }, 1032, ["class", "aria-label", "attrs", "onClick"])
        ]),
        default: s(() => [
          t("span", A, [
            m(j, { size: "800" }, {
              default: s(() => [
                t("p", N, c(o.emojiUnicodeOrShortname), 1),
                i[0] || (i[0] = t("br", null, null, -1)),
                t("p", R, [
                  k(c(o.names) + " ", 1),
                  t("span", {
                    class: "d-recipe-emoji-row__tooltip-label",
                    textContent: c(r.reactionLabel(o))
                  }, null, 8, U)
                ])
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 2
      }, 1032, ["onShown"])
    ]))), 128)),
    v(e.$slots, "picker")
  ]);
}
const X = /* @__PURE__ */ x(g, [["render", $]]);
export {
  X as default
};
//# sourceMappingURL=emoji-row.js.map
